import axios, { AxiosRequestConfig } from "axios";
import { deleteAllCookies } from "../utils/helpers/CommonFunction";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  // baseUrl:process.env.REACT_APP_LOCAL_URL,
  withCredentials: true, // Include credentials in the request
});
api.interceptors.response.use(
  (response: any) => {
    return response;
  },
  async (error: any) => {
    // 3. Handle 401 errors
    const originalRequest = error.config;

    // .isRetry is a non-axios property we use to differentiate the actual request from the one we're firing in this interceptor
    if (
      !originalRequest.url.includes("Account") &&
      error.response &&
      error.response?.status === 401 &&
      !originalRequest.isRetry
    ) {
      // originalRequest.isRetry = true
      // try {
      //   // fetch new tokens from our API
      //   const refreshToken = localStorage.getItem('refreshToken')
      //   const { data }:any = await axios.post('https://mabzoneapi.azurewebsites.net/api/Account/refresh?refreshToken='+refreshToken)

      //   // simplified for brevity
      //   localStorage.setItem('accessToken',data?.accessToken)

      //   // retry the original request
      //   originalRequest.headers = { ...originalRequest.headers, Authorization: `Bearer ${data.refreshToken}` }
      //   return api(originalRequest)
      // } catch (refreshError) {
      logoutUser();
      return Promise.reject(error);
      // }
    } else {
      return Promise.reject(error);
    }
  }
);

// Add a request interceptor to include the JWT token in the headers
api.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => {
    if (error.response.status === 401) {
      // Check if token is expired
      logoutUser();
    }
    return Promise.reject(error);
  }
);
export default api;
const logoutUser = () => {
  // Perform logout actions (e.g., clear token, redirect to login page)
  localStorage.clear();
  sessionStorage.clear();
  deleteAllCookies();

  // Redirect to login page or show a logout message
  if (!window.location.pathname.includes("auth")) {
    window.location.href = "/login";
  }
};

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await api.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error("Failed to fetch:", error);
    throw error;
  }
};

const Common = {
Employee: '/Employee',
Training: '/Training'
}

export const endpoints = {
  auth: {
    me: "Employee/GetEmployeeDetails?selfYN=true",
    signIn: "/api/auth/sign-in",
    signUp: "/api/auth/sign-up",
  },
  candidate: {
    hotlist: {
      get: "Jobs/GetHotListData",
      put: "Jobs/AddHotListCandidate",
      profile: "Jobs/GetProfileData",
      linkAdd: "Jobs/AddHotListLink",
      getLink: "Jobs/ValidateHotListLink",
    },
  },
  dashboard: {
    summarry: "Attendance/GetDashboardSummary",
    holidays: "Master/GetHolidayList",
    allHolidays: "Master/GetAllHolidays",
    birthday: "Employee/GetEmployeeBirthdayList",
    workAnniversarry: "Employee/GetEmployeeWorkAnniversaryList",
    task: "Tasks/GetTasksForDashBoard",
    leave: {
      upcoming: "",
      today: "",
    },
  },
  task: {
    detail: "Tasks/GetTask",
    list: 'Tasks/GetTaskDetails',
    insert: 'Tasks/InsertTask'
  },
  leave: {
    categories: "Master/GetLeaveCategories",
  },
  feedback: {
    customer: "Feedback/GetEmployeeFeedbackFromCustomer",
    admin: "Feedback/GetFeedbackQuestions",
    insertEvaluation: "Feedback/UpsertEmployeeEvaluation",
    getEvaluations: "Feedback/GetEmployeeEvaluationById",
  },
  employee: {
    list: "Employee/GetEmployeeCodes?isActive=1",
    detail: "Employee/GetEmployeeDetails",
    getAggreeMent: "Employee/GetEmployeeAgreementData",
    addAggreement: "Employee/InsertEmployeeAgreementData",
  },
  workStatus: {
    list: "",
  },
  project: {
    details: "Project/GetProjectDetails",
  },
  hotlist: {
    update: "Employee/UpdateHotList",
  },
  applicant: {
    update: "Jobs/",
  },
  blog:{
    get: 'Blogs',
    categories: 'Blogs/categories'
  },
  overtime: {
    getAll: `${Common.Employee}/GetEmployeeOvertimeAll`,
    getEmployee: `${Common.Employee}/GetEmployeeOvertimes`,
    add: `${Common.Employee}/AddOvertime`,
    addAdmin: `${Common.Employee}/AddOvertimeforAdminHR`,

  },
  asset:{
    category: 'User/GetAssetCategory',
    getAll: 'User/GetAssets'
  },
  job: {
    update: 'Jobs/UpdateJob',
    list: '/Jobs/GetJobsData'
  },
  student:{
    add: 'Master/student',
    list: 'Student/students',
    delete: 'Student/delete/student/',
    profile: 'Student/student'
  },
  training: {
    classes: {
      list: `${Common.Training}/sessions`,
      create: `${Common.Training}/session`
    },
    program: {
      list: `${Common.Training}/programs`,
      add: `${Common.Training}/program`
    },
    trainers: {
      list: `${Common.Training}/trainers`,
    }
  }
};

export const CONFIG ={
  siteUrl: process.env.REACT_APP_SERVER_URL,
  assetUrl: process.env.REACT_APP_ASSET_URL,
}
